import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput, FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface LockedYTMFormFieldProps {}

export const LockedYTMFormField: React.FC<LockedYTMFormFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ locked_ytm: number }>()

  return (
    <FormField
      name="locked_ytm"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Locked YTM</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput
              thousandSeparator={','}
              placeholder="Locked YTM"
              {...register('locked_ytm', { valueAsNumber: true })}
            />
          </FormItem>
        )
      }}
    />
  )
}
